import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/web/src/app/(site)/about/theory-of-action/components/theory-of-change/index.tsx");
